// HLS.js Video Initialization
(function() {
  function initHLSVideos() {
    // Check if any HLS videos exist first to avoid unnecessary execution
    const hlsVideos = document.querySelectorAll('video[data-hls-video]');
    if (hlsVideos.length === 0) return;
    
    // Wait for HLS.js library to be available
    if (typeof Hls === 'undefined') {
      setTimeout(initHLSVideos, 100);
      return;
    }
    
    hlsVideos.forEach(function(video) {
      // Skip if already initialized
      if (video.hasAttribute('data-hls-initialized')) return;
      video.setAttribute('data-hls-initialized', 'true');
      
      // Get the HLS and MP4 sources
      const sources = video.querySelectorAll('source');
      let hlsSource = null;
      let mp4Source = null;
      
      sources.forEach(function(source) {
        const sourceType = source.type || source.getAttribute('type');
        const sourceSrc = source.src || source.getAttribute('src');
        
        // Check for HLS/m3u8 sources
        if (sourceType === 'application/x-mpegURL' || 
            sourceType === 'application/vnd.apple.mpegurl' ||
            sourceSrc.indexOf('.m3u8') !== -1) {
          hlsSource = sourceSrc;
        } 
        // Check for MP4 sources
        else if (sourceType === 'video/mp4' || sourceSrc.indexOf('.mp4') !== -1) {
          mp4Source = sourceSrc;
        }
      });
      
      // If no HLS source found but it's a Shopify video, try to construct the HLS URL
      if (!hlsSource && mp4Source && mp4Source.indexOf('/cdn/shop/videos/') !== -1) {
        // Shopify video URLs follow a pattern - try to get the m3u8 version
        const videoIdMatch = mp4Source.match(/\/cdn\/shop\/videos\/c\/vp\/([a-f0-9]+)\//);
        if (videoIdMatch) {
          const videoId = videoIdMatch[1];
          hlsSource = mp4Source.split('.mp4')[0].split('/').slice(0, -1).join('/') + '/' + videoId + '.m3u8?v=0';
        }
      }
      
      if (!hlsSource) {
        console.warn('No HLS source found for video');
        return;
      }
      
      // Find the parent container for poster management
      const container = video.closest('.video-with-responsive-poster') || video.parentElement;
      
      // Ensure poster stays visible until video actually starts playing
      function showPoster() {
        if (container && container.classList) {
          container.classList.remove('playing');
        }
      }
      
      function hidePoster() {
        if (container && container.classList) {
          container.classList.add('playing');
        }
      }
      
      // CRITICAL: Show poster immediately
      showPoster();
      
      // Hide poster only when video actually starts playing
      video.addEventListener('playing', function() {
        hidePoster();
        video.setAttribute('data-video-started', 'true');
      });
      
      // Show poster when video is paused or waiting for data
      video.addEventListener('pause', function() {
        if (video.currentTime === 0) {
          showPoster();
          video.removeAttribute('data-video-started');
        }
      });
      
      video.addEventListener('ended', function() {
        showPoster();
        video.removeAttribute('data-video-started');
      });
      
      video.addEventListener('waiting', function() {
        if (video.currentTime === 0 || !video.hasAttribute('data-video-started')) {
          showPoster();
        }
      });
      
      // Check if HLS is supported natively or via HLS.js
      if (Hls.isSupported()) {
        // Use HLS.js for browsers that don't support HLS natively
        const hls = new Hls({
          enableWorker: true,
          lowLatencyMode: false,
          backBufferLength: 90,
          maxBufferLength: 30,
          maxMaxBufferLength: 60,
          maxBufferSize: 60 * 1000 * 1000,
          maxBufferHole: 0.5,
          startLevel: -1,
          testBandwidth: true,
          abrEwmaDefaultEstimate: 500000
        });
        
        hls.loadSource(hlsSource);
        hls.attachMedia(video);
        
        hls.on(Hls.Events.MANIFEST_PARSED, function() {
          if (video.autoplay || video.hasAttribute('autoplay')) {
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function(error) {
                console.log('Autoplay prevented:', error);
                showPoster();
              });
            }
          }
        });
        
        hls.on(Hls.Events.ERROR, function(event, data) {
          if (data.fatal) {
            console.warn('HLS fatal error, falling back to MP4:', data);
            showPoster();
            if (mp4Source) {
              video.src = mp4Source;
              if (video.autoplay || video.hasAttribute('autoplay')) {
                setTimeout(function() {
                  video.play().catch(function(error) {
                    console.log('MP4 autoplay prevented:', error);
                    showPoster();
                  });
                }, 100);
              }
            }
          }
        });
        
        video._hlsInstance = hls;
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // Native HLS support (Safari, iOS)
        video.src = hlsSource;
        if (video.autoplay || video.hasAttribute('autoplay')) {
          video.play().catch(function(error) {
            console.log('Native HLS autoplay prevented:', error);
            showPoster();
          });
        }
      } else if (mp4Source) {
        // No HLS support, use MP4 fallback
        video.src = mp4Source;
        if (video.autoplay || video.hasAttribute('autoplay')) {
          video.play().catch(function(error) {
            console.log('MP4 autoplay prevented:', error);
            showPoster();
          });
        }
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHLSVideos);
  } else {
    initHLSVideos();
  }
  
  // Also handle dynamically added videos
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.matches('video[data-hls-video]') || node.querySelector('video[data-hls-video]'))) {
            initHLSVideos();
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

